export default function Sass_Color() {
  return (
    <div>
      <h1>Sass Color</h1>
    </div>
  );
}
